export default (ex, extra, logger = 'wma-flightstats-com') => {
  console.log('report-exception', logger, ex, extra);
};
